import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) {
      navigate("/account");
      return;
    }

    api.post("/auth/session", { session_id: sessionId })
      .then((res) => {
        setUser(res.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { replace: true, state: { user: res.data.user } });
      })
      .catch(() => navigate("/account", { replace: true }));
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] grid place-items-center">
      <p className="font-serif text-2xl">Signing you in…</p>
    </div>
  );
}
